import { render, staticRenderFns } from "./renderless-sign-in.vue?vue&type=template&id=a22423c4&"
import script from "./renderless-sign-in.vue?vue&type=script&lang=ts&"
export * from "./renderless-sign-in.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports